export const GET_NOTIFICATIONS = `
query getNotifications {
  getNotifications {
    ... on Notification {
      id
      name
      description
      is_active
      is_active_editable
      uts
      its
      entity
      translation_key
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`